import Layout from "../components/layout/LandingPageLayout";
import {
  Box,
  Typography,
  Grid,
  Button,
  Card,
  CardContent,
  Divider,
  useTheme,
} from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Bar, Pie } from "react-chartjs-2";
import {Link} from "react-router-dom";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

const IntrectiveChartInfo = () => {
  const theme = useTheme();

  // Balance Sheet Data
  const balanceSheetData = {
    labels: ["Assets", "Liabilities", "Equity"],
    datasets: [
      {
        label: "₹ in Lakhs",
        data: [120, 70, 50],
        backgroundColor: [
          theme.palette.primary.main,
          theme.palette.secondary.main,
          theme.palette.success.main,
        ],
        borderRadius: 8,
      },
    ],
  };

  // Expense Breakdown Data
  const expenseData = {
    labels: ["Rent", "Salaries", "Utilities", "Marketing", "Other"],
    datasets: [
      {
        label: "Expenses",
        data: [30, 40, 10, 15, 5],
        backgroundColor: [
          theme.palette.error.main,
          theme.palette.info.main,
          theme.palette.warning.main,
          theme.palette.secondary.main,
          theme.palette.success.main,
        ],
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: { color: theme.palette.text.primary },
      },
      title: { display: false },
    },
    scales: {
      x: { ticks: { color: theme.palette.text.primary } },
      y: { ticks: { color: theme.palette.text.primary } },
    },
  };

  return (
    <Layout>
      <Box
        sx={{
          py: 8,
          px: 3,
          textAlign: "center",
          background: theme.palette.background.default,
        }}
      >
        {/* Heading */}
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          Smarter Financial Reports. Better Decisions.
        </Typography>
        <Typography
          variant="h6"
          color="text.secondary"
          sx={{ maxWidth: "700px", mx: "auto", mb: 6 }}
        >
          Our platform converts your financial data into meaningful insights.
          Explore balance sheets, expense breakdowns, and interactive reports
          that help you stay ahead.
        </Typography>

        <Divider sx={{ maxWidth: 400, mx: "auto", mb: 6 }} />

        {/* Charts */}
        <Grid container spacing={6} justifyContent="center">
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                boxShadow: 3,
                borderRadius: 3,
                height: "100%",
                transition: "0.3s",
                "&:hover": { transform: "translateY(-5px)", boxShadow: 6 },
              }}
            >
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Balance Sheet Overview
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                  Instantly see your company’s financial position with a clear
                  breakdown of assets, liabilities, and equity.
                </Typography>
                <Box sx={{ height: 300 }}>
                  <Bar data={balanceSheetData} options={chartOptions} />
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card
              sx={{
                boxShadow: 3,
                borderRadius: 3,
                height: "100%",
                transition: "0.3s",
                "&:hover": { transform: "translateY(-5px)", boxShadow: 6 },
              }}
            >
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Expense Breakdown
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                  Visualize how your money is spent — identify cost drivers and
                  optimize your budget.
                </Typography>
                <Box sx={{ height: 300 }}>
                  <Pie data={expenseData} options={chartOptions} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* CTA */}
        <Box mt={8}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Ready to unlock powerful insights?
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            Upload your reports today and get instant charts, balance sheets,
            and smart recommendations.
          </Typography>
          <Button
           componet={Link}
            to="/login"
            variant="contained"
            size="large"
            sx={{
              borderRadius: "30px",
              px: 5,
              py: 1.8,
              fontSize: "1rem",
              textTransform: "none",
              boxShadow: 4,
            }}
          >
            Get Started Now
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};

export default IntrectiveChartInfo;

